import React from "react";
import styled, { ThemeProvider } from "styled-components";
import megaphone from "~/images/megaphone.png";

const Announce = styled.div`
  height: 64px;
  display: flex;
  align-items: center;
  width: 100%;
  background: #e8e8e0 0% 0% no-repeat padding-box;
  box-shadow: -10px -10px 15px #ffffff, 9px 11px 11px #00000029;
  border-radius: 10px 40px;

  @media screen and (max-width: 1200px) {
    transform: scale(0.9);
  }

  @media screen and (max-width: 768px) {
    height: 50px;
  }

  @media screen and (max-width: 576px) {
    height: 40px;
  }

  .anounce-left {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 240px;
    height: 60px;
    background: #0396ff 0% 0% no-repeat padding-box;
    background: ${(props) => props.theme.color} 0% 0% no-repeat padding-box;
    border-radius: 10px 40px;

    > span {
      text-align: center;
      font: normal normal medium Kanit;
      font-size: 38px;
      letter-spacing: 0px;
      color: #e8e8e0;
      text-shadow: inset 0px 1px 2px #00000029;
      text-transform: uppercase;
    }

    > img {
      width: 40px;
      height: 40px;
    }

    @media screen and (max-width: 1200px) {
      > span {
        font-size: 30px;
      }

      > img {
        width: 30px;
        height: 30px;
      }
    }

    @media screen and (max-width: 768px) {
      height: 50px;
    }

    @media screen and (max-width: 576px) {
      height: 40px;

      > span {
        font-size: 14px;
      }

      > img {
        width: 20px;
        height: 20px;
      }
    }
  }

  .promo-panel {
    padding: 3px 0;
    width: 100%;
    letter-spacing: 0px;
  }

  .promo-text {
    overflow: hidden;
    position: relative;
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 64px;

    @keyframes scroll-left {
      0% {
        transform: translate(100%, -50%);
      }
      100% {
        transform: translate(-100%, -50%);
      }
    }

    p {
      display: inline-block;
      font-size: 30px;
      color: ${(props) => props.theme.color};
      position: absolute;
      width: 100%;
      margin: 0;
      padding-right: 100%;
      text-align: center;
      transform: translate(100%, -50%);
      animation: scroll-left 25s linear infinite;
      top: 50%;
    }

    @media screen and (max-width: 768px) {
      height: 50px;

      p {
        font-size: 20px;
      }
    }

    @media screen and (max-width: 576px) {
      height: 40px;

      p {
        font-size: 14px;
      }
    }
  }
`;

const colorTheme = {
  live22: {
    background:
      "transparent linear-gradient(180deg, #0396ff 0%, #0080db 100%) 0% 0% no-repeat padding-box",
    color: "#0396ff",
  },
  slotxo: {
    background:
      "transparent linear-gradient(180deg, #E40203 0%, #960E10 100%) 0% 0% no-repeat padding-box",
    color: "#E40203",
  },
  pgslot: {
    background:
      "transparent linear-gradient(180deg, #28BC7B 0%, #3DB741 100%) 0% 0% no-repeat padding-box",
    color: "#28BC7B",
  },
  joker: {
    background:
      "transparent linear-gradient(180deg, #FF12A4 0%, #DA0055 100%) 0% 0% no-repeat padding-box",
    color: "#FF12A4",
  },
  ambslot: {
    background:
      "transparent linear-gradient(180deg, #E59801 0%, #FAEB57 100%) 0% 0% no-repeat padding-box",
    color: "#FFB503",
  },
};

const AnounceComponent = ({ anounce, pageName }) => {
  return (
    <ThemeProvider theme={colorTheme[pageName]}>
      <div className="w-full mt-5">
        <Announce className="flex w-full">
          <div className="anounce-left mr-3">
            <img className="mr-5" src={megaphone} alt=""></img>
            <span>ประกาศ</span>
          </div>
          <div className="promo-panel flex justify-between">
            <div className="promo-text">
              <div
                dangerouslySetInnerHTML={{
                  __html: anounce,
                }}
              ></div>
            </div>
          </div>
        </Announce>
      </div>
    </ThemeProvider>
  );
};

export default AnounceComponent;
